import { da, pt } from 'date-fns/locale';

function getLanguagePackFromBrowser() {
  const lang = navigator.languages[0].split('-')[0];

  if (lang === 'da') {
    return da;
  }
  if (lang === 'pt') {
    return pt;
  }
  return null;
}

// eslint-disable-next-line import/prefer-default-export
export { getLanguagePackFromBrowser };
